function sortByObjectProp(
    items: any[],
    propName: string,
    reversed: boolean = false,
): any[] {
    const newArray = items.slice().sort((a, b) => {
        const x =
            typeof a[propName] === 'string'
                ? a[propName].split('')[0].toUpperCase()
                : a[propName];
        const y =
            typeof b[propName] === 'string'
                ? b[propName].split('')[0].toUpperCase()
                : b[propName];
        return reversed
            ? x > y
                ? -1
                : x < y
                ? 1
                : 0
            : x < y
            ? -1
            : x > y
            ? 1
            : 0;
    });

    return newArray;
}

export default sortByObjectProp;
